import { memo } from 'react';
import { Dialog, DialogContent, Box, Typography, Button, IconButton } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CloseIcon from '@mui/icons-material/Close';
import COLORS from '../../theme/Colors';
import { useHistory } from 'react-router';

function LoginOrRegisterModal({ open, onCloseClick }) {
    const history = useHistory();

    const goToRoute = (route) => {
        history.push(route);
        onCloseClick();
    };

    return (
        <Dialog
            open={open}
            onClose={onCloseClick}
            PaperProps={{
                sx: {
                    borderRadius: '24px',
                    maxWidth: '480px',
                    width: '90%',
                    overflow: 'hidden',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                }
            }}
        >
            <Box sx={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}>
                <IconButton
                    onClick={onCloseClick}
                    size="small"
                    sx={{
                        color: COLORS.secondary,
                        bgcolor: '#F1F5F9',
                        '&:hover': { bgcolor: '#E2E8F0' }
                    }}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>

            <DialogContent sx={{ p: { xs: 4, sm: 6 }, textAlign: 'center' }}>
                <Box
                    sx={{
                        width: 72,
                        height: 72,
                        borderRadius: '50%',
                        bgcolor: COLORS.primaryOpacity(0.1),
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mx: 'auto',
                        mb: 3
                    }}
                >
                    <AccountCircleIcon sx={{ fontSize: 40, color: COLORS.primary }} />
                </Box>

                <Typography
                    variant="h4"
                    sx={{
                        fontFamily: 'Merriweather, serif',
                        color: COLORS.secondary,
                        fontWeight: 700,
                        fontSize: { xs: '1.5rem', sm: '1.75rem' },
                        mb: 1.5,
                        letterSpacing: '-0.01em'
                    }}
                >
                    Necesitas iniciar sesión
                </Typography>

                <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4, fontSize: '1rem', lineHeight: 1.6, maxWidth: '360px', mx: 'auto' }}>
                    Para solicitar este servicio, inicia sesión o crea una cuenta gratuita en el portal.
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                    <Button
                        variant="contained"
                        fullWidth
                        onClick={() => goToRoute('/login')}
                        sx={{
                            bgcolor: COLORS.primary,
                            py: 1.6,
                            borderRadius: '10px',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            textTransform: 'none',
                            boxShadow: 'none',
                            '&:hover': {
                                bgcolor: COLORS.secondary,
                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.15)'
                            }
                        }}
                    >
                        Iniciar sesión
                    </Button>

                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={() => goToRoute('/registro')}
                        sx={{
                            color: COLORS.secondary,
                            borderColor: '#E2E8F0',
                            py: 1.6,
                            borderRadius: '10px',
                            fontSize: '1rem',
                            fontWeight: 'bold',
                            textTransform: 'none',
                            '&:hover': {
                                borderColor: COLORS.secondary,
                                bgcolor: '#F8FAFC'
                            }
                        }}
                    >
                        Crear una cuenta
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
export default memo(LoginOrRegisterModal);